import script from "./resetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPassword.vue?vue&type=script&setup=true&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=1c1ef67c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c1ef67c"]])

export default __exports__